module.exports = __webpack_public_path__ + "img/60-61.67824f87.png";